import Win from './win'

export default Win 